module.exports = __webpack_public_path__ + "static/img/z.a8713ea8.png";